import { render, staticRenderFns } from "./resultCard.vue?vue&type=template&id=137b7fe5&scoped=true"
import script from "./resultCard.vue?vue&type=script&lang=js"
export * from "./resultCard.vue?vue&type=script&lang=js"
import style0 from "./resultCard.vue?vue&type=style&index=0&id=137b7fe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b7fe5",
  null
  
)

export default component.exports